import * as React from 'react'
import * as style from './index.module.css'
import { SITE_URL, CONPANY_NAME } from '@/utils/const'

/**
 * @file copyright
 */
export const Copyright = (): React.JSX.Element => (
  <a
    href={SITE_URL}
    className={style.root}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={`${CONPANY_NAME}のコピーライト`}
  >
    {`© ${new Date().getFullYear()} ${CONPANY_NAME} All Rights Reserved`}
  </a>
)
